<template>
    <div class="flex flex-col h-full">
        <div class="flex flex-row justify-between mb-6 mt-1">
            <h1 class="text-3xl font-semibold text-gray-900 -mt-1">
                {{ $t('deliveries.pageTitle') }}
            </h1>
        </div>
    </div>
</template>

<script>
    // import { mapState } from 'vuex';
    // import ActivationForm from '@/components/Activation/ActivationForm.vue';
    // import ActivationsHistory from '@/components/Activation/ActivationsHistory.vue';

    export default {
        // components: {
        //     ActivationsHistory,
        //     ActivationForm,
        // },
        //
        // data() {
        //     return {
        //         //
        //     };
        // },
        //
        // computed: {
        //     ...mapState([
        //         'licenseTypes',
        //     ]),
        //
        //     licenseTypeOptions() {
        //         return this.licenseTypes.map(licenseType => {
        //             return {
        //                 count: licenseType.unactivatedLicenses,
        //                 label: licenseType.localized_name[this.$i18n.locale],
        //                 platform: licenseType.platform,
        //                 value: licenseType.id,
        //             };
        //         });
        //         // return [{
        //         //     count: 7,
        //         //     label: 'FN Elity',
        //         //     platform: 'oem',
        //         //     value: 1,
        //         // }];
        //     },
        //
        //     hasLicensesToActivate() {
        //         // return this.order.licenses
        //         //     .filter(license => !license.activation_date)
        //         //     .length;
        //         return true;
        //     },
        // },
        //
        // methods: {
        //     onLicenseActivated(license) {
        //         this.$refs.activationsHistory.onLicenseActivated(license);
        //     },
        // },
    };
</script>
